<template>
  <layouts-header v-if="!authStore.user"></layouts-header>
  <user-header v-if="authStore.user"></user-header>
  <breadcrumb :title="title" :text="text" :text1="text1" />
  <user-tabset></user-tabset>
  <div class="content">
    <div class="container">
      <!-- Statistics Card -->
       <div class="row" id="bang-dieu-khien">
          <statistics></statistics>
       </div>
      <!-- /Statistics Card -->
      <!-- Dashboard Table -->
       <!--giai-dau-Table-->
      <div class="row" id="giai-dau">
        <div class="content court-bg">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <div class="court-tab-content">
                  <div class="card card-tableset">
                    <div class="card-body">
                      <div class="tab-content">
                        <tournament-table></tournament-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--giai-dau-Table-->
      <!--tran-dau-table-->
      <div class="row" id="tran-dau">
        <div class="content court-bg">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">
                <div class="court-tab-content">
                  <div class="card card-tableset">
                    <div class="card-body">
                      <div class="tab-content">
                        <match-table></match-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--tran-dau-table-->
      <!-- /Dashboard Table -->
    </div>
  </div>
  <layout-footer></layout-footer>
  <user-dashboard-modal></user-dashboard-modal>
  
</template>
<script>
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    const authStore = useAuthStore();
    return {
      authStore,
      title: "Bảng điều khiển",
      text: "Trang chủ",
      text1: "Bảng điều khiển" ,
    };
  },
};
</script>
